import PrimaryButton from './PrimaryButton'
import ErrorButton from './ErrorButton'
import IconButton from './IconButton'
import BlackButton from './BlackButton'
import WhiteButton from './WhiteButton'
import CircleButton from './CircleButton'

const Button = {
  Primary: PrimaryButton,
  Error: ErrorButton,
  Icon: IconButton,
  Black: BlackButton,
  White: WhiteButton,
  Circle: CircleButton,
}

export default Button
